import SkeletonLoaderRow, {
  SkeletonWrapper,
} from 'components/loading/SkeletonLoaderRow';
import React from 'react';
import { StyledWrapper } from 'styles/ContainerStyles';

const SubscriptionLoader: React.FC = () => {
  return (
    <StyledWrapper mt={-15} mb={0}>
      <StyledWrapper center mb={0}>
        <SkeletonWrapper width={90}>
          <SkeletonLoaderRow height={90} />
        </SkeletonWrapper>
      </StyledWrapper>
      <StyledWrapper mt={10} mb={0}>
        <SkeletonWrapper width={220}>
          <SkeletonLoaderRow height={30} />
        </SkeletonWrapper>
      </StyledWrapper>
      <StyledWrapper mt={5} mb={0} center>
        <SkeletonWrapper width={120}>
          <SkeletonLoaderRow height={20} />
        </SkeletonWrapper>
      </StyledWrapper>
      <StyledWrapper mt={5} center>
        <SkeletonWrapper width={120}>
          <SkeletonLoaderRow height={20} />
        </SkeletonWrapper>
      </StyledWrapper>
      <StyledWrapper mt={10} center>
        <SkeletonWrapper width={220}>
          <SkeletonLoaderRow height={35} />
        </SkeletonWrapper>
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default SubscriptionLoader;
